import { render, staticRenderFns } from "./ProfileDialog.vue?vue&type=template&id=769d43ab&"
import script from "./ProfileDialog.vue?vue&type=script&lang=js&"
export * from "./ProfileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('769d43ab')) {
      api.createRecord('769d43ab', component.options)
    } else {
      api.reload('769d43ab', component.options)
    }
    module.hot.accept("./ProfileDialog.vue?vue&type=template&id=769d43ab&", function () {
      api.rerender('769d43ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/ProfileDialog.vue"
export default component.exports